// extracted by mini-css-extract-plugin
module.exports = {"root":"PendingPaymentAlert_root__spGiw","buttons":"PendingPaymentAlert_buttons__A1Jas"};